import Vue from 'vue';
import Component from 'vue-class-component';
import { TOOLS_STORE } from '@/tools/store/tools.store';
import Organization from '@/tools/models/organization.model';
import Department from '@/tools/models/department.model';
import EdCreateClassComponent from '@/classes/components/ed-create-class/ed-create-class.component.vue';
import EdListClassesComponent from '@/classes/components/ed-list-classes/ed-list-classes.component.vue';
import { ClassesService } from '@/classes/services/classes.service';
import EdSelectTabsComponent from '@/tools/components/ed-select-tabs/ed-select-tabs.component.vue';
import EdClassScheduleSelectTypeModal from '@/tools/components/class-builder/ed-class-schedule-select-type-modal/ed-class-schedule-select-type-modal.component.vue';
import { ScheduleService } from '@/tools/services/schedule.service';
import { ScheduleTypeEnum } from '@/tools/enums/schedule-type.enum';

@Component({
  name: 'class-admin',
  components: {
    EdCreateClass: EdCreateClassComponent,
    EdListClasses: EdListClassesComponent,
    EdSelectTabs: EdSelectTabsComponent
  }
})
export default class ClassAdminView extends Vue {

  /* Data */
  public organization: Organization = new Organization;
  public department: Department = new Department;
  public openCreateClass: boolean = false;
  data() {
    return {
      tabs: [
        { label: 'classes.builders.byClass', value: 'CLASS' },
        { label: 'classes.builders.byTeacher', value: 'TEACHER' },
        { label: 'classes.builders.byGrade', value: 'GRADE' },
      ],
      sortBy: 'CLASS',
    }
  }

  /* Computed */
  get writeClassPriv() {
    return this.$store.state.AuthStore.privileges.WriteClass;
  }

  /* Methods */
  createClass() {
    this.openCreateClass = !this.openCreateClass;
  }

  closeCreateClass() {
    this.openCreateClass = false;
  }

  onGoToCreateSchedule(classItem) {
    this.$EdModal.createModal(EdClassScheduleSelectTypeModal, {}, {
      classId: classItem.id,
      onContinue: async (scheduleType: ScheduleTypeEnum) => {
        await ScheduleService.updateScheduleTypeOptions(classItem.id, scheduleType);
        this.$router.push({ name: 'schedule', params: { classId: classItem.id }, query: { scheduleType } });
      }
    });
  }

  onGoToSchedulesEdition(classItem) {
    if (Array.isArray(classItem)) {
      const classIds = classItem.map((c) => c.id);
      this.$router.push({ name: 'schedule', params: { classId: classIds[0] }, query: { classIds } });
    } else {
      this.$router.push({ name: 'schedule', params: { classId: classItem.id }, query: { scheduleType: classItem.scheduleType } });
    }
  }

  onGoToClassBuilder(classItem) {
    this.$router.push({ name: 'builder', params: { classId: classItem.id } });
  }

  onGoToClassInactive(){
    this.$router.push({ name: 'inactive-classes', params: { departmentId: `${this.department['id']}` } });
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on('closeCreateClass', this.closeCreateClass);
    this.$store.dispatch(`${TOOLS_STORE.ACTIONS.GET_INSTITUTION_INFO}`).then(() => {
      this.organization = this.$store.state.ToolsStore.institutionInfo[0];
      ClassesService.getDepartmentByOrganizationId(
        this.organization['organizationId']
      ).then((res: any) => {
        this.department = res[0];
      })
    });
  }

  beforeDestroy() {
    this.$edEventBus.$off('closeCreateClass', this.closeCreateClass);
  }
}

interface Item {
  label: string;
  value: string;
}
